import type { Citation } from '@/types/chat';

/**
 * True when the cited extract was produced by a model from an image (description or OCR), not taken from the document.
 */
export const isAiGeneratedCitation = (citation: Pick<Citation, 'citesAiGeneratedContent'> | undefined): boolean =>
  citation?.citesAiGeneratedContent === true;
